import { render, staticRenderFns } from "./live-list.vue?vue&type=template&id=1d088974&"
import script from "./live-list.vue?vue&type=script&lang=js&"
export * from "./live-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports